import { useState } from 'react';
import { doesExist } from 'utils/tsHelpers';
import { CastType } from 'modules/queryBuilder/types';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import {
  CastTypePrefix,
  CastTypeSelectWrapper,
  Wrapper,
  CastTypeTriggerWrapper,
} from './ConditionCastTypeSelect.styles';
import { AnimationSlide } from './types';
import { useUnsetCastTypeOnNonEditMode } from './hooks';
import { ConditionCastTypeTrigger } from './ConditionCastTypeTrigger';
import { QueryBuilderSelect } from '../Selects';
import { ConditionSingleValueSelectProps } from '../types';

export const ConditionCastTypeSelect = ({
  onChange,
  value,
  ...props
}: ConditionSingleValueSelectProps<CastType>) => {
  const { t } = useTranslation();
  const [isEditMode, setIsEditMode] = useState<boolean>(doesExist(value));
  const [animationSlide, setAnimationSlide] = useState<AnimationSlide | null>(null);
  useUnsetCastTypeOnNonEditMode(animationSlide, isEditMode, onChange);

  const onClick = () => {
    if (!isEditMode) {
      setIsEditMode(true);
      setAnimationSlide(AnimationSlide.left);
    } else {
      setIsEditMode(false);
      setAnimationSlide(AnimationSlide.right);
    }
  };

  const triggerLabel = t(`storybook.castType.${isEditMode ? 'reset' : 'cast'}`);

  return (
    <Wrapper>
      {isEditMode && (
        <CastTypeSelectWrapper data-slide={animationSlide}>
          <CastTypePrefix>{t('storybook.castType.pretext')}</CastTypePrefix>
          <QueryBuilderSelect onChange={onChange} value={value} {...props} />
        </CastTypeSelectWrapper>
      )}
      <CastTypeTriggerWrapper data-slide={animationSlide}>
        <ConditionCastTypeTrigger onClick={onClick}>{triggerLabel}</ConditionCastTypeTrigger>
      </CastTypeTriggerWrapper>
    </Wrapper>
  );
};
